import React from "react"
import { connect } from "react-redux"

import { AuthenticationError, PermissionDeniedError, isPermittedPermission } from "./../../helpers"
import {ContentRoute} from "../router"


const ProtectedDialogRoute = ({ isAuthenticated = false, anonymous = true, can, isSuperuser,isDssb, permissions, ...props }) => {

  if (!isAuthenticated && !anonymous){
    throw new AuthenticationError()
  }

  if (!isSuperuser && !isDssb && !isPermittedPermission(can, permissions)){
    throw new PermissionDeniedError()
  }

  return (<ContentRoute {...props} />)
}


const mapStateToProps = (state) => state.common.auth

export default connect(mapStateToProps)(ProtectedDialogRoute)
